// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3MWKT","list":"styles_list__11Whm"};